// Fixed 24-color qualitative palette chosen for maximum mutual distinguishability,
// including for color-vision-deficient (colorblind) viewers — based on
// Green-Armytage's "colour alphabet" of maximally distinct colours.
const PALETTE = [
  '#0075DC', // blue
  '#FF0010', // red
  '#2BCE48', // green
  '#FFA405', // orange
  '#9DCC00', // lime
  '#C20088', // magenta
  '#003380', // navy
  '#740AFF', // violet
  '#993F00', // brown
  '#00998F', // turquoise
  '#FF5005', // red-orange
  '#5EF1F2', // cyan
  '#E0FF66', // pale lime
  '#F0A3FF', // light purple
  '#808080', // grey
  '#990000', // wine
  '#FFCC99', // pale orange
  '#426600', // olive
  '#8F7C00', // khaki
  '#005C31', // dark green
  '#4C005C', // dark purple
  '#94FFB5', // pale green
  '#FFA8BB', // pink
  '#FFE100'  // yellow
];

// Strong bit-mixing hash (FNV-1a + avalanche) so similar ids/names scatter across
// the palette instead of clustering on nearby colors. Deterministic: a given user
// always keeps the same color — but the mapping looks random rather than sequential.
const hashString = (str) => {
  const s = String(str || '');
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i += 1) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  h ^= h >>> 16;
  h = Math.imul(h, 0x45d9f3b);
  h ^= h >>> 16;
  h = Math.imul(h, 0x45d9f3b);
  h ^= h >>> 16;
  return h >>> 0;
};

// Deterministic auto color from the palette (used as the default before a user
// picks an explicit color in Settings).
export const getAutoUserColor = (user) => {
  const key = user && typeof user === 'object'
    ? (user.id || user.name || user.email || '')
    : user;
  if (!key) return null;
  return PALETTE[hashString(key) % PALETTE.length];
};

// Resolve a user's color: an explicit color chosen in Settings (keyed by user id)
// wins; otherwise fall back to the deterministic palette color. `colorMap` is the
// { userId: hex } map from settings.userColors.
// Accepts a user object ({ id, name, email }) or a raw id/name string.
// Returns null for an empty/unassigned value so callers can render a neutral state.
export const getUserColor = (user, colorMap) => {
  const id = user && typeof user === 'object' ? user.id : user;
  if (!user || (typeof user === 'object' && !id && !user.name && !user.email)) return null;
  const override = id && colorMap ? colorMap[id] : null;
  return override || getAutoUserColor(user);
};
